{
    "environment": "prod",
    "resource_sharing":"CORS",
    "endpoints":[{"path":"api/**", "urlAddress":"https://10.2.160.74:7443"},
                 {"path":"employee/**","urlAddress":"https://10.2.160.74:9443","pathRewrite":{"search":"employee/","replace":""}}],
    "tenantCode": "vjcp",
    "appId": "viejas",
    "contentServiceBaseUrl": "https://quhblx02i5.execute-api.us-east-1.amazonaws.com/prod/contentservice/App/",
    "userPoolId": "us-east-1_bUKKzgll5",
    "userPoolClientId": "6t0120e63eqjpajg4bjcgnh6r0",
    "excludeMenus": ["Tournament", "Account info"],
    "contact_us": {
      "mail": "",
      "us": "+1 619-445-5400",
      "text": "Question or Comments? We’d love your feedback."
    },
    "download_app_urls": {
      "iOS": "https://apps.apple.com/us/app/myviejas-rewards/id1606010126",
      "Android": "https://play.google.com/store/apps/details?id=com.qlx.myviejas&hl=en_IN"
    },
    "tokenRefreshBufferTime": 120,
    "tenantDesc": "9593ecd5ae22c66abaebb12ac91716a88f8b0a72cd0f81df5af6f69918681448d9201ac57d6763d3b572e7b5833db0f0c68c9e592f5cab40ee8c51eb7f487d497b7546831a49fc995a3d98d76f9ce8121778a33447b009d88d9cf81abbd0fddf43147230991984ed6b8ca0e53fd7f116996600a4794a2933319310c028a0ed98"
}